module.exports = __webpack_public_path__ + "img/info.0f432dae.svg";